import React from 'react';

export default () => (
<svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.52941 11.4706V6.17647H0L6.17647 0L12.3529 6.17647H8.82353V11.4706H3.52941ZM0 15V13.2353H12.3529V15H0Z" fill="#444444"/>
</svg>
);
